// Qué secciones de cada placa se pueden prender y apagar.
//
// Lo fijo NO está en estas listas: el encabezado y el pie siempre, y además
// lo que le da sentido a cada placa (los partidos de la noche, el campeón del
// mes). Una placa nueva trae su lista acá y el menú funciona solo.
//
// La elección se recuerda en cada celular, por placa. Se guardan las
// APAGADAS y no las prendidas: así una sección nueva sale prendida para todos
// en vez de quedar escondida sin que nadie la haya elegido.

import type { Noche, PlacaMes } from '../services/api';

export interface SeccionPlaca {
  id: string;
  nombre: string;
}

export type TipoPlaca = 'noche' | 'mes';

export const SECCIONES: Record<TipoPlaca, readonly SeccionPlaca[]> = {
  noche: [
    { id: 'tabla', nombre: 'Cómo se movió la tabla' },
    { id: 'figura', nombre: 'Figura' },
    { id: 'el1', nombre: '“El 1”' },
    { id: 'logros', nombre: 'Logros' },
  ],
  mes: [
    { id: 'podio', nombre: '2º y 3º' },
    { id: 'reconocimientos', nombre: 'Reconocimientos' },
    { id: 'numeros', nombre: 'Números' },
    { id: 'pareja', nombre: 'Pareja' },
    { id: 'destacados', nombre: 'Destacados' },
    { id: 'logros', nombre: 'Logros' },
  ],
};

/**
 * Las secciones que ESTA placa tiene para mostrar. Un botón que no cambia
 * nada (la figura de una noche sin figura) confunde: no se ofrece.
 */
export function disponiblesNoche(n: Noche): string[] {
  return [
    n.movimientos.length > 0 && 'tabla',
    n.figuras.length > 0 && 'figura',
    n.el_1_nuevo && 'el1',
    n.logros.length > 0 && 'logros',
  ].filter((x): x is string => typeof x === 'string');
}

export function disponiblesMes(d: PlacaMes): string[] {
  const destacados = d.racha || d.siempre || d.mas_peleado.length > 0;
  return [
    d.podio.some((f) => f.posicion > 1) && 'podio',
    (d.mas_subio.length > 0 || d.mas_presente.length > 0) && 'reconocimientos',
    'numeros',
    d.pareja && 'pareja',
    destacados && 'destacados',
    d.logros.length > 0 && 'logros',
  ].filter((x): x is string => typeof x === 'string');
}

const clave = (tipo: TipoPlaca) => `placa.apagadas.${tipo}`;

export function leerApagadas(tipo: TipoPlaca): Set<string> {
  try {
    const guardado = JSON.parse(localStorage.getItem(clave(tipo)) ?? '[]') as unknown;
    return new Set(Array.isArray(guardado) ? guardado.filter((x) => typeof x === 'string') : []);
  } catch {
    return new Set();
  }
}

export function guardarApagadas(tipo: TipoPlaca, apagadas: ReadonlySet<string>): void {
  try {
    localStorage.setItem(clave(tipo), JSON.stringify([...apagadas]));
  } catch {
    // Sin almacenamiento la elección vale para esta vez y listo.
  }
}
